import { render, staticRenderFns } from "./VatDataForm.vue?vue&type=template&id=22b5ef54&scoped=true&"
import script from "./VatDataForm.vue?vue&type=script&lang=js&"
export * from "./VatDataForm.vue?vue&type=script&lang=js&"
import style0 from "./VatDataForm.vue?vue&type=style&index=0&id=22b5ef54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5ef54",
  null
  
)

export default component.exports